import React from "react";

import { Checkbox } from '../../Ui'

import RightsTableData	from "./RightsTableData";

const RightsTableDataCheckbox = ({ checked, onClick }) =>
	<RightsTableData>
		<Checkbox
			checked={checked}
			onClick={onClick} />
	</RightsTableData>

export default RightsTableDataCheckbox;



// WEBPACK FOOTER //
// ./src/js/plan/rights/RightsTableDataCheckbox.js